module.exports = __webpack_public_path__ + "media/images/two_doors-76f5c00dde9d578f6235790e0af69d50.svg";